import React, { useEffect } from 'react';
import { NextPageWithLayout } from '@/pages/_app';
import { Layout } from '@/components/Common';
import { SEO_META } from '@/shared/seo';
import { SEO_META_PAGES } from '@/shared/types/seo';
import { logPageView } from '@/lib/service';
import { LOGISTICS_AND_FULFILLMENT_CONTENT } from '@/shared/constants/platform-pages-constants';
import PlatformPage from '@/components/Platform';
import { WEBSITE_URL, STATIC_FILE_URL } from '@/shared/constants';
import CustomHead from '@/components/Common/Layout/Head';

const IdeationPage = ({}: NextPageWithLayout<any>) => {
  useEffect(() => {
    logPageView({
      pageUrl: window.location.href || '',
      routeName: window.location.pathname,
      pageTitle: `${LOGISTICS_AND_FULFILLMENT_CONTENT.title} | Pietra`,
    });
  }, []);
  return <PlatformPage content={LOGISTICS_AND_FULFILLMENT_CONTENT} utmSource="logistics_and_fulfillment" />;
};

IdeationPage.getLayout = (page: React.ReactElement) => {
  return (
    <>
      <CustomHead
        title="Logistics & Fulfillment | Pietra"
        description="A private 3PL designed for scaling brands across DTC, wholesale, and retail using Pietra. Saving brands 30%+ on commodity services."
        url={`${WEBSITE_URL}/platform/logistics-and-fulfillment`}
        image={`${STATIC_FILE_URL}/e432783eea6d241981ef0e7abbab56e1.png`}
      />
      <Layout
        structured={SEO_META[SEO_META_PAGES.IDEATION].jsonld({
          url: typeof window === 'object' ? window.location.href : '',
        })}
      >
        {page}
      </Layout>
    </>
  );
};

export default IdeationPage;
